import styled from 'react-emotion';

const WidgetPreviewContainer = styled.div`
  margin: 15px 2px;
`;

export default WidgetPreviewContainer;
